(function () {
  'use strict';

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function formatEUR(cents) {
    const euros = Math.round(cents) / 100;
    return '€\u00a0' + euros.toFixed(2).replace('.', ',');
  }

  class PzQuickBuy {
    constructor(el) {
      this.el = el;
      this.panel = el.querySelector('.pz-qb__panel');
      this.badge = el.querySelector('[data-pz-qb-badge]');
      this.image = el.querySelector('[data-pz-qb-image]');
      this.tag = el.querySelector('[data-pz-qb-tag]');
      this.area = el.querySelector('[data-pz-qb-area]');
      this.titleEl = el.querySelector('[data-pz-qb-title]');
      this.descEl = el.querySelector('[data-pz-qb-desc]');
      this.qtyEl = el.querySelector('[data-pz-qb-qty]');
      this.totalEl = el.querySelector('[data-pz-qb-total]');
      this.priceDetailEl = el.querySelector('[data-pz-qb-price-detail]');
      this.compareEl = el.querySelector('[data-pz-qb-compare]');
      this.discountEl = el.querySelector('[data-pz-qb-discount]');
      this.minusBtn = el.querySelector('[data-pz-qb-minus]');
      this.plusBtn = el.querySelector('[data-pz-qb-plus]');
      this.submitBtn = el.querySelector('[data-pz-qb-submit]');
      this.submitLabel = el.querySelector('.pz-qb__submit-label');
      this.submitLabelDefault = this.submitLabel ? this.submitLabel.textContent : 'Aggiungi';
      this.detailLink = el.querySelector('[data-pz-qb-detail]');
      this.errorEl = el.querySelector('[data-pz-qb-error]');

      this.current = null;
      this.qty = 1;
      this.lastFocus = null;

      this.bind();
    }

    bind() {
      this.el.querySelectorAll('[data-pz-qb-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      if (this.minusBtn) this.minusBtn.addEventListener('click', () => this.setQty(this.qty - 1));
      if (this.plusBtn) this.plusBtn.addEventListener('click', () => this.setQty(this.qty + 1));
      if (this.submitBtn) this.submitBtn.addEventListener('click', () => this.addToCart());

      document.addEventListener('keydown', (e) => {
        if (!this.isOpen()) return;
        if (e.key === 'Escape') { e.preventDefault(); this.close(); }
        if (e.key === 'Tab') this.trapFocus(e);
      });

      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-pz-quickbuy]');
        if (!btn) return;
        if (btn.disabled) return;
        e.preventDefault();
        // Mobile: skip modal, direct AJAX add + toast
        if (window.matchMedia('(max-width: 749px)').matches) {
          this.addToCartDirect(btn.dataset, btn);
          return;
        }
        this.open(btn.dataset, btn);
      });
    }

    isOpen() {
      return this.el.getAttribute('aria-hidden') === 'false';
    }

    trapFocus(e) {
      const nodes = Array.from(this.el.querySelectorAll(FOCUSABLE)).filter((n) => !n.hidden && n.offsetParent !== null);
      if (nodes.length === 0) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    open(data, trigger) {
      this.current = Object.assign({}, data);
      this.qty = 1;
      this.lastFocus = trigger || document.activeElement;
      this.clearError();

      if (data.productBadge) {
        this.badge.textContent = data.productBadge.toUpperCase();
        this.badge.hidden = false;
      } else {
        this.badge.hidden = true;
      }

      if (this.image) {
        this.image.src = data.productImage || '';
        this.image.alt = data.productTitle || '';
      }

      if (data.productType) {
        this.tag.textContent = data.productType;
        this.tag.hidden = false;
      } else {
        this.tag.hidden = true;
      }

      if (data.productArea) {
        this.area.textContent = data.productArea.toUpperCase();
        this.area.hidden = false;
      } else {
        this.area.hidden = true;
      }

      this.titleEl.textContent = data.productTitle || '';

      if (data.productDesc) {
        this.descEl.innerHTML = data.productDesc;
        this.descEl.hidden = false;
      } else {
        this.descEl.innerHTML = '';
        this.descEl.hidden = true;
      }

      this.detailLink.setAttribute('href', data.productUrl || '#');

      this.qtyEl.textContent = this.qty;
      this.updateTotal();

      this.el.hidden = false;
      requestAnimationFrame(() => {
        this.el.setAttribute('aria-hidden', 'false');
        document.body.classList.add('pz-qb-lock');
        const closeBtn = this.el.querySelector('.pz-qb__close');
        if (closeBtn) closeBtn.focus();
      });
    }

    close() {
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pz-qb-lock');
      setTimeout(() => {
        this.el.hidden = true;
        if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
      }, 220);
    }

    setQty(v) {
      this.qty = Math.max(1, v | 0);
      this.qtyEl.textContent = this.qty;
      this.updateTotal();
    }

    updateTotal() {
      if (!this.current) return;
      const priceCents = parseInt(this.current.productPrice, 10) || 0;
      const compareCents = parseInt(this.current.productCompareAtPrice, 10) || 0;
      this.totalEl.textContent = formatEUR(priceCents * this.qty);
      if (this.priceDetailEl) {
        if (compareCents > priceCents) {
          const discountPct = Math.round((compareCents - priceCents) * 100 / compareCents);
          if (this.compareEl) this.compareEl.textContent = formatEUR(compareCents * this.qty);
          if (this.discountEl) this.discountEl.textContent = '−' + discountPct + '%';
          this.priceDetailEl.hidden = false;
        } else {
          this.priceDetailEl.hidden = true;
        }
      }
    }

    setError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }

    addToCartDirect(data, btn) {
      const variantId = parseInt(data.productId, 10);
      if (!variantId) return;
      const qty = 1;
      const originalHTML = btn.innerHTML;
      btn.disabled = true;
      // Locale-aware URLs
      const root = document.querySelector('[data-pz-qb]');
      const addUrl = (root && root.dataset.cartAddUrl) || '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (window.PzCartToast) window.PzCartToast.show(qty);
        })
        .catch(function (err) { console.error('[pz-quickbuy] mobile add failed', err); })
        .finally(function () {
          setTimeout(function () { btn.disabled = false; btn.innerHTML = originalHTML; }, 800);
        });
    }

    async addToCart() {
      if (!this.current || !this.current.productId) return;
      this.submitBtn.disabled = true;
      this.submitBtn.classList.add('pz-qb__submit--loading');
      this.clearError();

      try {
        // Locale-aware URLs: iniettate dal Liquid tramite data-cart-url / data-cart-add-url
        // che usano {{ routes.cart_url }} e {{ routes.cart_add_url }} (rispettano /en/ ecc.)
        const root = document.querySelector('[data-pz-qb]');
        const addUrl = (root && root.dataset.cartAddUrl) || '/cart/add.js';
        const cartUrl = (root && root.dataset.cartUrl) || '/cart';
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: this.current.productId, quantity: this.qty }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Errore nell\'aggiunta al carrello');
        }
        window.location.href = cartUrl;
      } catch (err) {
        this.setError(err.message || 'Impossibile aggiungere al carrello. Riprova.');
        this.submitBtn.disabled = false;
        this.submitBtn.classList.remove('pz-qb__submit--loading');
      }
    }
  }

  function init() {
    const el = document.querySelector('[data-pz-qb]');
    if (!el || el.__pzQbInit) return;
    el.__pzQbInit = true;
    new PzQuickBuy(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
